import BaseCollection from "lib/collection";
import Inventory from "models/inventory";

export default BaseCollection.extend({
    mainIndex: "sku_id",

    url() {
        if (this.parent.id && this.parent.collection.parent._id) {
            return `/api/v3.0/item/${this.parent.collection.parent._id}/warehouse/${this.parent.id}/available-inventory`;
        }
        throw Error("Must have parent id");
    },

    model: Inventory,
});
